import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SearchResult } from '../../models/search-result.model';
import { ResultItemComponent } from '../result-item/result-item.component';
import { TranslationService } from '../../services/translation.service';

@Component({
  selector: 'app-results-list',
  standalone: true,
  imports: [CommonModule, ResultItemComponent],
  templateUrl: './results-list.component.html'
})
export class ResultsListComponent {
  @Input() results: SearchResult[] = [];
  @Input() loading = false;
  @Input() hideFacets = false;
  @Output() resultClick = new EventEmitter<{ id: string; typeId?: string; position: number }>();

  constructor(private readonly translation: TranslationService) {}

  get noResultsLabel(): string {
    return this.translation.translate('noResults');
  }
}
